// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Djibouti */
const DJ = /^(?:77\d{6})$/;

export default DJ;
